import { ref } from 'vue';
import { Load as ES } from './lang/es.js';
import { Load as EN } from './lang/en.js';


const data =
{
	es: ES(),
	en: EN()
};


const current_tx = ref( data.es );


export const i18n =
{
	
	lang: ref( 'es' ),
	
	Change_lang: function ( lang )
	{
		if ( lang in data )
			current_tx.value = data[lang];
		
		this.lang.value = lang;
	}
	
};


export function tx ( key, lang = null )
{
	return txc( key, null, lang );
}


export function txc ( key, context, lang = null )
{
	let origin;
	
	switch ( true )
	{
		case ( lang === null ) && ( context === null ) && ( key in current_tx.value ): return current_tx.value[key];
		case ( lang === null ) && ( context in current_tx.value ) && ( key in current_tx.value[context] ): return current_tx.value[context][key];
		
		case ( lang in data ) && ( context === null ) && ( key in data[lang] ): return data[lang][key];
		case ( lang in data ) && ( context in data[lang] ) && ( key in data[lang][context] ): return data[lang][context][key];
	}
	
	return key;
}


export function txs ( structure )
{
	if ( !structure )
		return '';
	
	if ( structure instanceof Object )
	{
		if ( !( 'key' in structure ) || !( 'context' in structure ) )
			return '';
		
		return txc( structure.key, structure.context );
	}
	
	return tx( structure );
}
